import {Shipment} from '@domain/model/Shipment/Shipment';

import {ShipmentRepository} from '@domain/model/Shipment/ShipmentRepository';
import {request} from '@infra/api/fetch/request';

const getShipmentByOrderReference = async (orderReference: string): Promise<Shipment> => {
  const url = `/api/shipments/orderReference=${orderReference}`;

  return request({url, method: 'GET'});
};

const getShipmentByServiceId = async (serviceId: string): Promise<Shipment> => {
  const url = `/api/shipments/serviceId=${serviceId}`;

  return request({url, method: 'GET'});
};

const ApiShipmentRepository: ShipmentRepository = {
  getShipmentByOrderReference: getShipmentByOrderReference,
  getShipmentByServiceId: getShipmentByServiceId,
};

export {ApiShipmentRepository};
